import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButtonLevelSection from "../../components/button/primary-button/PrimaryButtonLevelSection";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import ImageFromUrl from "../../components/parseImage/ImageFromUrl";
import ScrollRefWrapper from "../../detail-components/ScrollRefWrapper";
import { checkIsVn, getConstantStringByLanguage } from "../../templates/helper/getConstantStringByLanguage";
import ConstantStrings from "../../constants/ConstantStrings";
import PopupCloseButton from "../../components/button/special-button/PopupCloseButton";
import PrimaryButtonPageLevel from "../../components/button/primary-button/PrimaryButtonLevelPage";

const ExamPractice = () => {
  const [showPopup,setShowPopup] = useState(false)
  const navigate = useNavigate();

  const removePopup = () => {
    setShowPopup(false);
  };
  return (
    <div
      className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center is-relative"
      style={{ minHeight: "100vh", top: "-5.25rem" }}
    >
      <ScrollRefWrapper />
      {showPopup && <div
        className="modal is-active is-justify-content-center"
        style={{ zIndex: 1000 }}
      >
        <div className=" modal-background" style={{ opacity: "0.8" }}></div>
        <div
          className="has-background-kurio-main-color-white is-relative is-flex is-flex-direction-column is-align-items-center"
          style={{
            borderRadius: "2rem",
            height: "auto",
            maxHeight: "84.7%",
            width: "auto",
            padding: "4rem",
          }}
        >
          <div
            className="is-flex is-flex-direction-column is-align-items-center select-service pr-2"
            style={{ overflowY: "auto", gap: "2.5rem" }}
          >
            <p className="is-uppercase is-size-1 has-text-kurio-main-color-black has-text-weight-bold">
              {getConstantStringByLanguage(ConstantStrings.COMING_SOON)}
            </p>
            <PrimaryButtonPageLevel onClick={removePopup}>
              {getConstantStringByLanguage(ConstantStrings.CLOSE)}
            </PrimaryButtonPageLevel>
          </div>

          <div
            onClick={removePopup}
            className=""
            style={{
              position: "absolute",
              top: "-8%",
              left: "-4%",
              zIndex: 9999,
              background: "transparent",
              border: "none",
              width: "5rem",
              fontSize: "2rem",
            }}
          >
            <PopupCloseButton />
          </div>
        </div>
      </div>}
      <div className="is-flex is-flex-direction-column is-align-items-center is-flex-gap-5 ">
        <p
          className="has-text-weight-bold has-text-kurio-main-color-black"
          style={{
            fontSize: "2rem",
            lineHeight: "normal",
            fontStyle: "normal",
          }}
        >
          {getConstantStringByLanguage(ConstantStrings.EXAM_PRACTICE)}
        </p>

        <div className=" is-flex is-flex-gap-6 is-align-items-flex-start is-justify-content-center">
          <BackgroundImageFromUrl
            objectId={
              "admin/frontend-images/exam-practice/bg-exam-practice-ikmc.png"
            }
            className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
            style={{
              border: "0.09375rem solid #0A2A66",
              borderRadius: "1rem",
              width: "25rem",
              height: "25rem",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              boxShadow: "0.125rem 0.25rem 0rem 0rem #0A2A66",
            }}
          >
            <div
              className="is-flex is-flex-direction-column is-flex-gap-4 is-align-items-center is-justify-content-center"
              style={{ width: "20.5rem" }}
            >
              <img
                style={{
                  width: "7.5rem",
                  height: "7.5rem",
                  objectFit: "cover",
                }}
                src="/images/practice-ikmc/menu-ikmc-left-icon.svg"
                alt=""
              />
              <p
                className="has-text-weight-normal has-text-centered has-text-kurio-main-color-white"
                style={{
                  fontSize: "2rem",
                  fontFamily: "Dela Gothic One",
                  fontStyle: "normal",
                  lineHeight: "110%",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.IKMC_EXAM)}
              </p>
              <p
                className="has-text-centered has-text-centered has-text-kurio-main-color-white"
                style={{
                  fontSize: "1rem",
                  fontStyle: "normal",
                  lineHeight: "normal",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.IKMC_EXAM_MESSAGE)}
              </p>
              <PrimaryButtonLevelSection
                onClick={() => navigate("/practice-ikmc")}
                isDarkColor={true}
              >
                {getConstantStringByLanguage(ConstantStrings.DISCOVER)}
              </PrimaryButtonLevelSection>
            </div>
          </BackgroundImageFromUrl>
          <BackgroundImageFromUrl
            objectId={
              "admin/frontend-images/exam-practice/bg-exam-practice-semester.png"
            }
            className="is-flex is-align-items-center is-justify-content-center has-text-kurio-main-color-purple"
            style={{
              border: "0.09375rem solid #0A2A66",
              borderRadius: "1rem",
              width: "25rem",
              height: "25rem",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              boxShadow: "0.125rem 0.25rem 0rem 0rem #0A2A66",
            }}
          >
            <div
              className="is-flex is-flex-direction-column is-flex-gap-4 is-align-items-center is-justify-content-center"
              style={{ width: "20.5rem" }}
            >
              <ImageFromUrl
                style={{
                  width: "7.5rem",
                  height: "7.5rem",
                  objectFit: "cover",
                }}
                objectId="admin/frontend-images/auth/image-left-signup.svg"
                alt=""
              />
              <p
                className="has-text-weight-normal has-text-centered"
                style={{
                  fontSize: "2rem",
                  fontFamily: "Dela Gothic One",
                  fontStyle: "normal",
                  lineHeight: "110%",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.SEMESTER_EXAM)}
              </p>
              <p
                className="has-text-centered"
                style={{
                  fontSize: "1rem",
                  fontStyle: "normal",
                  lineHeight: "normal",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.SEMESTER_EXAM_DESCRIPTION)}
              </p>
              <PrimaryButtonLevelSection
                onClick={() => {
                  if (checkIsVn()) {
                    navigate("/semester-exam-preparation")
                  } else {
                    setShowPopup(true);
                  }
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.DISCOVER)}
              </PrimaryButtonLevelSection>
            </div>
          </BackgroundImageFromUrl>
        </div>
      </div>
    </div>
  );
};

export default ExamPractice;
